// get products
export const getProducts = (products, category, type, limit) => {
  let finalProducts = [...products];

  // 1. Filtrar por tipo (si se proporciona)
  if (type) {
    switch (type) {
      case 'new':
        finalProducts = finalProducts.filter(product => product.new);
        break;
      case 'liquidacion':
        finalProducts = finalProducts.filter(product => product.liquidacion === true);
        break;
      case 'oferta':
        finalProducts = finalProducts.filter(product => product.oferta === true);
        break;
      default:
        break;
    }
  }

  // 2. Filtrar por categoría (solo si se proporciona)
  // Utiliza el método 'some' para verificar si la categoría existe en el array.
  // La condición `category` se evalúa como verdadera si la cadena no está vacía.
  if (category) {
    finalProducts = finalProducts.filter(product =>
      product.category.some(cat => cat.toLowerCase() === category.toLowerCase())
    );
  }

  // 3. Limitar el número de productos
  if (limit) {
    finalProducts = finalProducts.slice(0, limit);
  }
  
  // Agrega este console.log para ver el resultado final
  console.log("Productos filtrados:", finalProducts);

  return finalProducts;

  
  /*const finalProducts = category
  ? products.filter(product =>
      product.category.some(single => single === category)
    )
  : products;

console.log("Productos filtrados:", finalProducts);
*/

/*  const finalProducts = (category && category !="")
    ? products.filter(product =>
      product.category.some(single => single === category)
    )*/
    /*? products.filter(
        product => product.category.some(category)//.filter(single => single === category)[0]
      )*/
    //: products;
/*
    console.log("contenido de categoria2:",finalProducts);
  console.log("Products filtrados:",products);
  console.log("Productos filtrados:",finalProducts);
    console.log("Products filtrados:",products);
    console.log("Productos filtrados:",finalProducts);*/
  /*const finalProducts = category
    ? products.filter(product =>
        product.category.some(single => single === category)
      )
    : products;
*/
/*
  if (type && type === "new") {
    const newProducts = finalProducts.filter(single => single.new);
    return newProducts.slice(0, limit ? limit : newProducts.length);
  }
  if (type && type === "bestSeller") {
    return finalProducts
      .sort((a, b) => {
        return b.saleCount - a.saleCount;
      })
      .slice(0, limit ? limit : finalProducts.length);
  }
  if (type && type === "saleItems") {
    const saleItems = finalProducts.filter(
      single => single.discount && single.discount > 0
    );
    return saleItems.slice(0, limit ? limit : saleItems.length);
  }
  return finalProducts.slice(0, limit ? limit : finalProducts.length);
  */
};

// get product discount price
export const getDiscountPrice = (price, discount) => {
  return discount && discount > 0 ? price - price * (discount / 100) : null;
};

// get product cart quantity
export const getProductCartQuantity = (cartItems, product, color, size) => {
  let productInCart = cartItems.find(
    single =>
      single.code === product.code &&
      (single.selectedProductColor
        ? single.selectedProductColor === color
        : true) &&
      (single.selectedProductSize ? single.selectedProductSize === size : true)
  );
  if (cartItems.length >= 1 && productInCart) {
    if (product.variation) {
      return cartItems.find(
        single =>
          single.code === product.code &&
          single.selectedProductColor === color &&
          single.selectedProductSize === size
      ).quantity;
    } else {
      return cartItems.find(single => product.code === single.code).quantity;
    }
  } else {
    return 0;
  }
};

export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single.color === color)[0]
      .size.filter(single => single.name === size)[0].stock;
  }
};

//get products based on category
export const getSortedProducts = (products, sortType, sortValue) => {
  if (products && sortType && sortValue) {
    if (sortType === "category") {
      return products.filter(
        product => product.category.filter(single => single === sortValue)[0]
      );
    }
    if (sortType === "tag") {
      return products.filter(
        product => product.tag.filter(single => single === sortValue)[0]
      );
    }
    if (sortType === "search") {
      const searchTerm = sortValue.toLowerCase();
      return products.filter(product => {
        const nameMatch = product.name.toLowerCase().includes(searchTerm);
        const skuMatch = product.sku && product.sku.toLowerCase().includes(searchTerm);
        const categoryMatch = product.category && product.category.some(cat => cat.toLowerCase().includes(searchTerm));
        const tagMatch = product.tag && product.tag.some(tag => tag.toLowerCase().includes(searchTerm));
        
        return nameMatch || skuMatch || categoryMatch || tagMatch;
      });
    }
    if (sortType === "color") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(single => single.color === sortValue)[0]
      );
    }
    if (sortType === "size") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter(
            single => single.size.filter(single => single.name === sortValue)[0]
          )[0]
      );
    }
    if (sortType === "filterSort") {
      let sortProducts = [...products];
      if (sortValue === "default") {
        return sortProducts.sort((a, b) => {
          const la = (a.linea || '').trim().toLowerCase();
          const lb = (b.linea || '').trim().toLowerCase();
          if (la !== lb) return la.localeCompare(lb, 'es');
          return a.name.localeCompare(b.name, 'es');
        });
      }
      if (sortValue === "priceHighToLow") {
        return sortProducts.sort((a, b) => {
          const priceA = a.user_price ?? a.price;
          const priceB = b.user_price ?? b.price;
          return priceB - priceA;
        });
      }
      if (sortValue === "priceLowToHigh") {
        return sortProducts.sort((a, b) => {
          const priceA = a.user_price ?? a.price;
          const priceB = b.user_price ?? b.price;
          return priceA - priceB;
        });
      }
    }
  }
  return products;
};

// get individual element
const getIndividualItemArray = array => {
  let individualItemArray = array.filter(function(v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = products => {
  let productCategories = [];
  products &&
    products.map(product => {
      return (
        product.category &&
        product.category.map(single => {
          if (typeof single === 'string' && single.trim() && isNaN(single.trim())) {
            return productCategories.push(single);
          }
        })
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories.sort();
};

// get individual tags
export const getIndividualTags = products => {
  let productTags = [];
  products &&
    products.map(product => {
      return (
        product.tag &&
        product.tag.map(single => {
          return productTags.push(single);
        })
      );
    });
  const individualProductTags = getIndividualItemArray(productTags);
  return individualProductTags;
};

// get individual colors
export const getIndividualColors = products => {
  let productColors = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return productColors.push(single.color);
        })
      );
    });
  const individualProductColors = getIndividualItemArray(productColors);
  return individualProductColors;
};

// get individual sizes
export const getProductsIndividualSizes = products => {
  let productSizes = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map(single => {
          return single.size.map(single => {
            return productSizes.push(single.name);
          });
        })
      );
    });
  const individualProductSizes = getIndividualItemArray(productSizes);
  return individualProductSizes;
};

// get product individual sizes
export const getIndividualSizes = product => {
  let productSizes = [];
  product.variation &&
    product.variation.map(singleVariation => {
      return (
        singleVariation.size &&
        singleVariation.size.map(singleSize => {
          return productSizes.push(singleSize.name);
        })
      );
    });
  const individualSizes = getIndividualItemArray(productSizes);
  return individualSizes;
};

export const setActiveSort = e => {
  let filterValue;
  if (typeof e === 'string') {
    filterValue = e.trim();
  } else if (e && e.currentTarget) {
    filterValue = e.currentTarget.textContent.trim();
  }
  //} else {
  //  return; // No hacer nada si el parámetro no es válido
  //}
  
  // console.log("current fiilter value:", filterValue);
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
    if (item.textContent.trim() === filterValue) {
      item.classList.add("active");
    }
  });
};

export const setActiveLayout = e => {
  const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
  gridSwitchBtn.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const resolveProductImage = (imagePath) => {
  if (!imagePath) return process.env.PUBLIC_URL + '/assets/img/product/small-image/no-image.jpg';
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('//')) {
    return imagePath;
  }
  // Path root-relativo: evita que se resuelva relativo a la ruta actual (ej. /product/AM-1022).
  return process.env.PUBLIC_URL + (imagePath.startsWith('/') ? imagePath : `/${imagePath}`);
};

export const getBestPromoForQuantity = (promociones, quantity) => {
  if (!promociones || !promociones.length || !quantity) return null;
  let best = null;
  for (const promo of promociones) {
    const minQty = Number(promo.cantidad_minima);
    const isBulto = promo.tipo_promocion?.toLowerCase().includes('bulto');
    const applies = isBulto
      ? minQty > 0 && quantity % minQty === 0
      : quantity >= minQty;
    if (applies && (!best || Number(promo.descuento) > Number(best.descuento))) {
      best = promo;
    }
  }
  return best;
};

export const getPriceWithPromo = (basePrice, promociones, quantity) => {
  const promo = getBestPromoForQuantity(promociones, quantity);
  if (!promo || !basePrice) return basePrice;
  return basePrice * (1 - Number(promo.descuento) / 100);
};

export const toggleShopTopFilter = e => {
  const shopTopFilterWrapper = document.querySelector(
    "#product-filter-wrapper"
  );
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};
